import * as yup from 'yup';

export const initialValuesStepTwo = {
  name: '',
  state: '',
  city: '',
  municipality: '',
  colony: '',
  street: '',
  postalCode: '',
  interiorNumber: '',
  exteriorNumber: ''
};

export const initialTouchedStepTwo = {
  name: true,
  state: true,
  city: true,
  municipality: true,
  colony: true,
  street: true,
  postalCode: true,
  interiorNumber: true,
  exteriorNumber: true
};

export const schemaStepTwo = yup.object().shape({
  name: yup
    .string()
    .required('Requerido')
    .min(3, 'Mínimo 3 caracteres')
    .max(100, 'Máximo 100 caracteres'),
  state: yup.string().required('Requerido'),
  city: yup.string().required('Requerido'),
  municipality: yup.string().required('Requerido'),
  street: yup
    .string()
    .required('Requerido')
    .min(3, 'Mínimo 3 caracteres')
    .max(100, 'Máximo 100 caracteres'),
  postalCode: yup.string().required('Requerido').length(5, 'Revisar'),
  colony: yup.string().required('Requerido'),
  exteriorNumber: yup
    .string()
    .required('Requerido')
    .min(1, 'Mínimo 1 carácter')
    .max(10, 'Máximo 10 caracteres'),
  interiorNumber: yup
    .string()
    .min(1, 'Mínimo 1 carácter')
    .max(10, 'Máximo 10 caracteres')
});
